import { all } from "redux-saga/effects";
import { combineReducers } from "redux";

import { authReducerActions } from "../app/modules/Auth";
import storage from "redux-persist/lib/storage";
import { authReducer, authSaga } from "../app/modules/Auth";
import { dsReducer, dsSaga } from "../app/modules/Dashboard";
import { rtReducer, rtSaga } from "../app/modules/ReceiptTracking";
import { uiReducer, uiSaga } from "../app/modules/UI";
import { refReducer, refSaga } from "../app/modules/Administration/ReferenceInfoManagement";
import { agencyReducer, agencySaga } from "../app/modules/Administration/AgencyManagement";
import { serviceReducer, serviceSaga } from "../app/modules/Administration/ServiceManagement";
import { serviceItemReducer, serviceItemSaga } from "../app/modules/Administration/ServiceItemManagement";
import { reportReducer, reportSaga } from "../app/modules/Reporting";
import { provinceSaga, provinceReducer } from "../app/modules/Administration/ProvinceInfoManagement"
import { disputeResolutionReducer, disputeResolutionSaga } from "../app/modules/DisputeResolution";


const appReducer = combineReducers({
  auth: authReducer,
  ui: uiReducer,
  reference: refReducer,
  agency: agencyReducer,
  services: serviceReducer,
  serviceItem: serviceItemReducer,
  dashboard: dsReducer,
  receiptTracking: rtReducer,
  reports: reportReducer,
  province: provinceReducer,
  disputeResolution: disputeResolutionReducer
});

export const rootReducer = (state, action) => {
  if ( action.type.localeCompare(authReducerActions.loggedOut) === 0) {
    // for all keys defined in your persistConfig(s)
    storage.removeItem('persist:user-access-key');
    storage.removeItem('persist:root');
    state = undefined;
  }
  return appReducer(state, action);
};


export function* rootSaga() {
  yield all([
    authSaga(),
    uiSaga(),
    dsSaga(),
    rtSaga(),
    refSaga(),
    agencySaga(),
    serviceSaga(),
    serviceItemSaga(),
    reportSaga(),
    provinceSaga(),
    disputeResolutionSaga()
    
  ]);
};
